import { create } from "zustand";

interface RankedDetailsModalStore {
  puuid: string;
  isOpened: boolean;
  open: (puuid: string) => void;
  close: () => void;
}

const useRankedDetailsModalStore = create<RankedDetailsModalStore>()((set) => ({
  puuid: "",
  isOpened: false,
  open: (puuid) => set({ puuid, isOpened: true }),
  close: () => set({ puuid: "", isOpened: false }),
}));

export default useRankedDetailsModalStore;
